import { render, staticRenderFns } from "./system_music_list.vue?vue&type=template&id=037e93b4"
import script from "./system_music_list.vue?vue&type=script&lang=js"
export * from "./system_music_list.vue?vue&type=script&lang=js"
import style0 from "./system_music_list.vue?vue&type=style&index=0&id=037e93b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports